import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { ISchemasEnum } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

const subSchemas: Partial<SubWebsocketMessageRequest> = {
  view: 'pln',
  s: 'model',
};

@Injectable({
  providedIn: 'root',
})
export class SchemasService extends HttpEntityManager<
  ISchemasEnum,
  ISchemasEnum
> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'sma';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  constructor() {
    super();
  }

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...subSchemas, ...payload }, true);
  }

  createSchema(schema: Omit<ISchemasEnum, '_id'>): void {
    this.wsManager.create({ res: schema });
  }

  updateAttribute(payload: any): void {
    this.wsManager.update({ res: payload, id: payload.sid });
  }

  getSchema(sid: string): void {
    this.wsManager.get({ id: sid, view: 'pln' });
  }
}
